import Progress from './progresss';
import Benefits from './benefits';

export default () => {

    return (
        <>
            <div className="vip-20-top">
                <Progress />
                <Benefits />
            </div>
        </>
    )
}